<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-menu
        left
        offset-y
        content-class="overflow-y-hidden dropmenu"
        bottom
        min-width="150"
    >
        <template v-slot:activator="{ on }">
            <div v-on="on">
                <AccountAvatar
                    text-color="main"
                    text-class="font-weight-medium subtitle-2"
                    class="cursor-pointer"
                    :color="current_account.avatar ? 'transparent' : 'g3'"
                    :initials="current_account.initials"
                    :image-path="current_account.avatar"
                />
            </div>
        </template>
        <v-card>
            <v-row
                no-gutters
                align="baseline"
            >
                <v-col class="subtitle-2 font-weight-bold py-2 px-4">
                    {{ current_account | format_name }}
                </v-col>
            </v-row>
            <v-divider />
            <v-list dense>
                <v-list-item
                    v-for="(item, index) in menu_items"
                    :key="index"
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="onMenuItemClick(item)"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
import { $t } from "@/i18n";
import AccountModule from "../../store/modules/account";
import AccountAvatar from "../../components/AccountAvatar";
import router from "../../router";

export default {
    name: "AppToolbarAccountMenu",
    components: { AccountAvatar },
    props: {
        isMobile: {
            type: Boolean
        }
    },
    setup(props) {
        const { current_account, logoutUser } = AccountModule();

        let menu_items = [];
        if (!props.isMobile) {
            menu_items.push({ text: $t("Activity log"), route: { name: "activitylog" }});
            menu_items.push({ text: $t("Profile"), route: { name: "profile" }});
        }
        menu_items.push({
            text: $t("Log out"),
            action: () => {
                logoutUser();
            }
        });

        const onMenuItemClick = item => {
            if (item.route) {
                router.push(item.route);
            }
            if (item.action) {
                item.action();
            }
        };

        return {
            menu_items,
            current_account,
            onMenuItemClick
        };
    }
};
</script>
